// src/components/PapeleraEmpresas.jsx
import React, { useState, useEffect } from 'react';
import companiesApi from '../api/companiesApi';
import styles from './PapeleraEmpresas.module.css';

export default function PapeleraEmpresas() {
  const [deletedCompanies, setDeletedCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [restoreInput, setRestoreInput] = useState('');

  useEffect(() => {
    fetchDeleted();
  }, []);

  const fetchDeleted = async () => {
    try {
      const data = await companiesApi.getDeletedCompanies();
      setDeletedCompanies(data);
    } catch (err) {
      console.error('Error cargando empresas eliminadas:', err);
    }
  };

  const openModal = (company) => {
    setSelectedCompany(company);
    setRestoreInput('');
  };
  const closeModal = () => {
    setSelectedCompany(null);
    setRestoreInput('');
  };

  const confirmRestore = async () => {
    if (restoreInput.trim().toLowerCase() !== 'restaurar') return;
    try {
      await companiesApi.restoreCompany(selectedCompany._id);
      closeModal();
      fetchDeleted();
    } catch (err) {
      console.error('Error restaurando empresa:', err);
      alert('No se pudo restaurar la empresa.');
    }
  };

  return (
    <div className={styles.papeleraContainer}>
      <h1>Papelera de Empresas</h1>
      {deletedCompanies.length === 0 ? (
        <p>No hay empresas eliminadas.</p>
      ) : (
        <ul className={styles.list}>
          {deletedCompanies.map((comp) => (
            <li key={comp._id} className={styles.listItem}>
              <span className={styles.companyName}>{comp.name}</span>
              <button
                className={styles.restoreButton}
                onClick={() => openModal(comp)}
              >
                Restaurar
              </button>
            </li>
          ))}
        </ul>
      )}

      {selectedCompany && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <p className={styles.modalText}>
              ¿Deseas restaurar la empresa <strong>{selectedCompany.name}</strong>?<br />
              Para restaurarla escribe la palabra{' '}
              <span className={styles.greenText}>"restaurar"</span>:
            </p>
            <input
              type="text"
              className={styles.modalInput}
              value={restoreInput}
              onChange={(e) => setRestoreInput(e.target.value)}
            />
            <div className={styles.modalButtons}>
              <button
                type="button"
                className={styles.confirmButton}
                onClick={confirmRestore}
                disabled={restoreInput.trim().toLowerCase() !== 'restaurar'}
              >
                Restaurar
              </button>
              <button
                type="button"
                className={styles.cancelButton}
                onClick={closeModal}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
